<template>
	<div>
		<el-table class="qcTable" :data="list" v-loading="loading">
			<el-table-column prop="Id" label="任务编号" min-width="100"></el-table-column>
			<el-table-column prop="Name" v-if="type!=1" label="名称"></el-table-column>
			<el-table-column prop="CategoryName" min-width='110' label="抽样类型">
				<template slot-scope="scope">
					<span :title="scope.row.CategoryName">{{scope.row.CategoryName || '--'}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="QCPlanName" v-if="type!=1" label="评分方案"></el-table-column>
			<el-table-column prop="StatusCode" label="状态"></el-table-column>
			<el-table-column v-if="statusList!=15&&statusList!=50" min-width='100' prop="Progress" label="质控进度">
				<template slot-scope="scope">
					<el-tooltip effect="dark" placement="top-start">
						<div class="progress">
					       <div class="progress-bar progress-bar-success" :style="`width: ${Math.floor((scope.row.Progress.split('/')[0]/scope.row.Progress.split('/')[1])*100)}%`">
					      </div>
					      <span class="sr-only">{{(Math.floor((scope.row.Progress.split('/')[0]/scope.row.Progress.split('/')[1])*100))}}%</span>
					    </div>
					    <div slot="content" class="tableTooltip">
							<div>
								<em></em>
								<span>已完成数量:{{scope.row.Progress.split('/')[0]}}</span>
							</div>
						</div>
				    </el-tooltip>
				</template>
			</el-table-column>
			<el-table-column prop="Progress" min-width='100' label="报告总数">
				<template slot-scope="scope">
					<span>{{scope.row.Progress.split('/')[1]}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="CreateDt" :formatter="formattertime" width='100' :show-overflow-tooltip="type!=1?false:true" label="创建时间"></el-table-column>
			<el-table-column prop="ComepleteDt" width='100' :formatter="formattertime" :show-overflow-tooltip="type!=1?false:true" label="完成时间"></el-table-column>
			<el-table-column prop="CreateorName" min-width='100' label="创建人"></el-table-column>
			<el-table-column prop="" label="操作" min-width="100" fixed="right" >
				<template slot-scope="scope">
					<span class="table-task-btn detail" @click="taskClick(scope.row)">详情</span>
					<!-- <span class="table-task-btn textColorRed" v-if="scope.row.Status == 15" @click="withdraw(scope.row)">撤回</span> -->
					<div class="inblock" v-if="type!=1">
						<el-dropdown  v-if="scope.row.CanDistribute||scope.row.CanCancel||scope.row.StatusCode=='已完成'||scope.row.CanUnable||scope.row.Status == 15">
							<span class="el-dropdown-link">
								更多<i class="el-icon-arrow-down"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="a" v-if="scope.row.CanDistribute"><span @click="distributionClick(scope.row)">分配</span></el-dropdown-item>
								<el-dropdown-item command="b" v-if="scope.row.Status == 15"><span @click="withdraw(scope.row)">撤回</span></el-dropdown-item>
								<el-dropdown-item command="c" v-if="scope.row.StatusCode=='已完成'"><span @click="exportClick(scope.row)">导出</span></el-dropdown-item>
								<el-dropdown-item command="d" v-if="scope.row.CanCancel"><span @click="delterClick(scope.row)">取消</span></el-dropdown-item>
								<el-dropdown-item command="e" v-if="scope.row.CanUnable"><span @click="delectClick(scope.row)">删除</span></el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
					<!-- <span v-if="!scope.row.CanDistribute" class="table-task-btn distribute grlybtn">分配</span> -->
					<!-- <span v-if="scope.row.CanDistribute" class="table-task-btn distribute" @click="distributionClick(scope.row)">分配</span>
					<span v-if="scope.row.CanCancel" class="table-task-btn salmon" @click="delterClick(scope.row)">取消</span>
					<span v-if="scope.row.StatusCode=='已完成'" class="table-task-btn export" @click="exportClick(scope.row)">导出</span>
					<span v-if="scope.row.CanUnable" class="table-task-btn delete" @click="delectClick(scope.row)">删除</span> -->
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>
<style scoped>
	.el-form-item {
		margin-bottom: 10px !important;
	}
</style>
<script>
	import Api from '../../api'
	import axios from '@/js/api'
	import { mapState, mapActions, mapMutations } from 'vuex'
	export default {
		props: ['list','type'],
		data() {
			return {
				filtersz: [],
				recordExpands: '',
				expands: [],
				getRowKeys(row) {
					return row.Id
				},
			}
		},
		computed: {
			...Vuex.mapState('managerPlanList', ['reviewName','statusList', 'SamplingTaskGuId', 'loading','taskListTitle']),
			...Vuex.mapState('managerUser', ['newWorkTeamFrom']),
			...Vuex.mapState('breadcrumb', ['collapseflag','expertflag']),
		},
		mounted() {
			localStorage.removeItem('SamplingTaskGuId');
		},
		activated() {
			if (JSON.parse(sessionStorage.getItem('store'))) {
				let status = JSON.parse(sessionStorage.getItem('store')).managerPlanList.statusList;
				if (status != 0) {
					this.setDoctorStatus(status);
				}else{
					this.setDoctorStatus('0');
				}
			}
			this.GetCreatedTaskList();
			this.setLoading(true);
			this.setIsSubmint(true);
			this.setisSubmintflag(true);
			if(document.getElementsByClassName('el-main')[0]){
				document.getElementsByClassName('el-main')[0].scrollTop = 0;
			}
		},
		methods: {
			...Vuex.mapMutations('breadcrumb',['setTootipType','clearRow']),
			...Vuex.mapMutations('doctor', ['setisSubmintflag','setIsSubmint']),
			...Vuex.mapMutations('managerPlanList', ['setDoctorStatus','currentChangesSecond','setSplitScreen', 'setSecondListParameter', 'setSecondList', 'setLoading','setTaskSecond','setTaskStatus','clearSecondListParameter']),
			...Vuex.mapActions('managerPlanList', ['UpdateTaskEnable','GetCreatedTaskList','GetReportListByTask', 'cancelList','GetToDistributeInfo','GetTaskDetail','GetExpertReportList','RollBackExpertTaskByTaskId']),
			formattertime(row, column, cellValue){
				if (cellValue!=''&&cellValue!=null) {
					return cellValue.substring(0,cellValue.length-3);
				}else{
					return '--';
				}
			},
			withdraw(row){
				let _this = this;
				_this.$confirm('是否确定撤回已分配医生的报告？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					_this.RollBackExpertTaskByTaskId({
						SamplingTaskGuid:row.SamplingTaskGuid
					})
				}).catch((err) => {
					_this.$message({
						type: 'info',
						message: '已取消撤回'
					});
				});
				
			},
			//导出
			exportClick(row){
				window.open(axios.exportExcel(Api.api.manager.GetTaskTop5ReduceItem)+'?samplingTaskGuid='+row.SamplingTaskGuid+'&exportExcel=true&userGuid='+JSON.parse(localStorage.getItem('user')).sid);
			},
			distributionClick(row) {
				//清空分配数据并打开分配
				this.newWorkTeamFrom.Experts=[];
				localStorage.setItem('SamplingTaskGuId',row.SamplingTaskGuid);
				localStorage.removeItem('NewWorkTeamFromExpertsList')
				localStorage.removeItem('pagedataList')
				this.SamplingTaskGuId.SamplingTaskGuid = row.SamplingTaskGuid;
				this.GetToDistributeInfo();
				this.$router.push('/home/manager/task/taskall/distributionTask');
			},
			//点击进入列表页
			taskClick(row){
				this.setLoading(true)
				//clear
				this.setTootipType(false);
				this.clearRow();
				this.reviewName.name = '';
				this.currentChangesSecond(1);
				this.collapseflag.flag = false;
				this.expertflag.flag = false;
				this.SamplingTaskGuId.SamplingTaskGuid = row.SamplingTaskGuid;
				this.SamplingTaskGuId.ExpertUserGuid = '';
				this.taskListTitle.Id = row.Id;
				this.taskListTitle.name = row.Name;
				this.taskListTitle.categoryName = row.CategoryName;
				this.setDoctorStatus(this.statusList);
				this.$router.push('/home/manager/task/tasksecondaryTable')
			},
			delterClick(row) {
				this.SamplingTaskGuId.SamplingTaskGuid = row.SamplingTaskGuid;
				this.$confirm('是否确定取消本任务序列？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.cancelList()
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			},
			delectClick(row) {
				this.$confirm('是否确定删除本任务？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.UpdateTaskEnable({taskIds:[row.SamplingTaskGuid]})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},

		}

	}
</script>
<style scoped="scoped">
	 .el-dropdown-link {
		color: #248AFD;
	}
	
	 .el-icon-arrow-down {
		color: #248AFD !important;
	}
	
	.el-dropdown-menu__item:focus,
	.el-dropdown-menu__item:not(.is-disabled):hover {
		color: #248AFD !important;
	}
</style>